import { ROUND_HEADCOUNT_CLOSER_DECIMAL } from '../../constants'

/**
 * Round number to the closest 0.25 decimal
 */
export const roundDecimalToQuarter = (count: number) => {
  const multiplier = 1 / ROUND_HEADCOUNT_CLOSER_DECIMAL
  return Number((Math.round(count * multiplier) / multiplier).toFixed(2))
}
